import styled from 'styled-components';
import { ColumnDiv, Div } from 'styles/elements/div';
import { Error } from 'styles/blocks/error';
import media from 'styles/media';

const CompoundAnswer = styled(ColumnDiv)``;

const Answer = styled(ColumnDiv)`
  flex: 1 1 auto;
  ${props => (props.answerStyles ? props.answerStyles : '')};
  ${media.IE9 ? `
    margin: 0;
    width: auto;
  ` : ''};
  ${media.smallAndBelow`
    margin: 0;
    width: auto;
  `};
  
`;

const AnswersContainer = styled(Div)`
  flex-direction: column;
  ${media.smallAndBelow`
    margin: 0;
  `};
  ${props => (props.containerStyles ? props.containerStyles : '')};
`;

const QuestionText = styled.p`
  margin-bottom: 0.5em;
`;

const CompoundError = styled(Error)`
  margin-bottom: 10px;
  margin-top: 0;
`;

CompoundAnswer.Answer = Answer;
CompoundAnswer.AnswersContainer = AnswersContainer;
CompoundAnswer.QuestionText = QuestionText;
CompoundAnswer.Error = CompoundError;

export default CompoundAnswer;
